import { CircularProgress, Grid, Typography } from '@mui/material';
import { runCellSegmentation } from 'api/platform';
import { modelTypeCellSegmentation } from 'components/Pages/Jobs/inferenceFieldsOptions';
import { JobType } from 'interfaces/job';
import { useSnackbar } from 'notistack';
import React, { ReactElement } from 'react';
import { SubmitHandler } from 'react-hook-form';
import { CasesParams } from 'utils/useCasesParams/types';
import { useMutationWithErrorSnackbar } from 'utils/useMutationWithErrorSnackbar';
import { GenericInferenceDependantJobValues, RunCellDetectionDependentJob } from './CellDetectionDependentJob';

const SNACK_BAR_KEY_RUN_CELL_SEGMENTATION = 'RUN_CELL_SEGMENTATION';

export interface RunCellSegmentationProps {
  onClose: (event?: any, force?: boolean) => void;
  casesParams: CasesParams;
}

export const RunCellSegmentation = (props: RunCellSegmentationProps): ReactElement => {
  const { onClose, casesParams } = props;
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const runCellSegmentationnMutation = useMutationWithErrorSnackbar({
    mutationFn: runCellSegmentation,
    mutationDescription: 'run cell segmentation',
    onSuccess: () => {
      enqueueSnackbar('Cell Segmentation Started', { variant: 'success' });
      onClose(undefined, true);
    },
    onSettled() {
      closeSnackbar(SNACK_BAR_KEY_RUN_CELL_SEGMENTATION);
    },
  });

  const onSubmit: SubmitHandler<any> = (data: GenericInferenceDependantJobValues) => {
    runCellSegmentationnMutation.mutate({
      ...casesParams,
      ...data,
    });

    enqueueSnackbar({
      variant: 'success',
      message: (
        <Grid container>
          <Grid item>
            <Typography>Waiting for Cell Segmentation to start</Typography>
          </Grid>
          <Grid item>
            <CircularProgress sx={{ marginLeft: 10 }} color="inherit" size={20} />
          </Grid>
        </Grid>
      ),
      key: SNACK_BAR_KEY_RUN_CELL_SEGMENTATION,
      autoHideDuration: null,
    });
  };

  return (
    <RunCellDetectionDependentJob
      onSubmit={onSubmit}
      casesParams={casesParams}
      jobType={JobType.CellSegmentation}
      modelType={modelTypeCellSegmentation}
    />
  );
};
